import React from 'react'

// styles
import './index.scss'

const Clients = (props) => {
  const { row } = props
  return (
    <div className="clients vh-center flex">
      {
        row.map((item, i) => {
          return (
            <div className="client-padd" key={`${item + i}`}>
              <div className={`inner ${item}`}></div>
            </div>
          )
        })
      }
    </div>
  )
}

export default Clients